import { createSlice } from '@reduxjs/toolkit';

export const ticketCategoryReducer = createSlice({
  name: 'ticketCategory',
  initialState: { ticketCategoryList: null, loading: false, allCategories: null },
  reducers: {
    setTicketCategoryLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setTicketCategoryList: (state, { payload }) => {
      state.ticketCategoryList = payload;
    },
    setTicektCategoryAllCategories: (state, { payload }) => {
      state.allCategories = payload;
    },
  },
});

export const { setTicketCategoryLoading, setTicketCategoryList, setTicektCategoryAllCategories } = ticketCategoryReducer.actions;

export default ticketCategoryReducer.reducer;
